import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import { BusinessArea, PropertyType } from '@ev-tech/search-modules-api';

export function useSelectedState() {
  const objectTypeCategory = useSearchStore((state) => state.objectTypeCategory);
  const propertyTypeLandState = useSearchStore((state) => state.propertyTypeState[objectTypeCategory][PropertyType.land]);

  const isLandSelected =
    propertyTypeLandState?.selected || Object.values(propertyTypeLandState?.subTypes ?? {}).some((subType) => subType.selected);
  const isDevelopmentSelected = objectTypeCategory === 'development';
  const isCommercialSelected = objectTypeCategory === BusinessArea.commercial;

  return { isLandSelected, isDevelopmentSelected, isCommercialSelected };
}
